"use client";

import { Button } from "@repo/ui/components/button";
import { useEffect } from "react";

interface ClientRouteErrorFallbackProps {
	error: Error & { digest?: string };
	/** Next.js segment reset — often insufficient for stale client ReferenceErrors. */
	reset: () => void;
}

/**
 * Marketing/app route error UI. Prefer a full document reload over soft
 * `reset()`: client ReferenceErrors (missing bindings after HMR / partial
 * module graphs) re-throw immediately on reset, which makes Try again appear
 * to no-op.
 */
export function ClientRouteErrorFallback({
	error,
}: ClientRouteErrorFallbackProps) {
	useEffect(() => {
		console.error(error);
	}, [error]);

	function handleReload() {
		window.location.reload();
	}

	return (
		<div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-6 text-center">
			<h1 className="font-semibold text-lg">Something went wrong</h1>
			<p className="max-w-md text-muted-foreground text-sm">
				This page hit an unexpected error. Reload to restore a clean
				copy of the page.
			</p>
			<Button type="button" onClick={handleReload}>
				Reload page
			</Button>
		</div>
	);
}
